<div class="component-expense-type">
  <div class="row mb-2">
    <div class="col-12">
      <ng-select
        bindLabel="name"
        bindValue="code"
        attr.name="{{ name }}"
        notFoundText="Nenhuma despesa encontrada"
        attr.data-cy="{{ dataCy }}"
        [(ngModel)]="selectedExpenseId"
        [readonly]="readOnly"
      >
        <ng-option *ngFor="let item of expenses" [value]="item.id">{{
          item.code + " - " + item.name
        }}</ng-option>
      </ng-select>
    </div>
  </div>
</div>
